// extracted by mini-css-extract-plugin
export default {"Card":"BookCard_Card__WSoY5"};